import { z } from 'zod';
import { AffixIdSchema, AffixListSchema, MAX_AFFIXES } from '../data/affix-ids.js';
/**
 * The runesmith (ADR 0057). The client names the piece and the affixes it
 * locks; the server knows where the player stands, what the reroll costs,
 * and draws.
 */
export const ReforgeItemMessageSchema = z.object({
    itemId: z.uuid(),
    /** Kept whole. */
    locks: z.array(AffixIdSchema).max(MAX_AFFIXES),
    /** Kept in kind, with a new value. */
    values: z.array(AffixIdSchema).max(MAX_AFFIXES).default([]),
    /** Kept whole and sealed for good. */
    seals: z.array(AffixIdSchema).max(MAX_AFFIXES).default([]),
});
/** To the owner alone, after the reroll; the new inventory follows. */
export const ReforgeResultSchema = z.object({
    itemId: z.uuid(),
    templateId: z.string().min(1),
    before: AffixListSchema,
    affixes: AffixListSchema,
});
export const REFORGE_REFUSALS = [
    'invalid',
    'unknown-item',
    'not-affixable',
    'all-locked',
    'unknown-lock',
    'sealed',
    'missing-materials',
    'missing-gold',
    'too-far',
    'rate-limited',
    'closed',
];
export const ReforgeRejectedSchema = z.object({
    reason: z.enum(REFORGE_REFUSALS),
    /** Milliseconds until the next reroll is accepted, when rate-limited. */
    retryInMs: z.number().int().min(0).optional(),
});
//# sourceMappingURL=reforge.js.map